import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=3e9ba572&lang=pug"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GroupSelect: require('/home/docker/code/frontend/components/GroupSelect.vue').default,DateTimeInput: require('/home/docker/code/frontend/components/DateTimeInput.vue').default,Location: require('/home/docker/code/frontend/components/Location.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,ClientSelect: require('/home/docker/code/frontend/components/ClientSelect.vue').default})
